import { QueryClient } from '@tanstack/react-query';

// Single source of the dashboard's query defaults. Focus refetch is off: an
// operator returning to a background tab must not wake the database (Neon bills
// awake time). A screen that needs it opts in with `refetchOnWindowFocus: true`.
export function makeQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 60 * 1000, // 1 minute
        gcTime: 5 * 60 * 1000, // 5 minutes
        refetchOnWindowFocus: false,
        retry: (failureCount, error: unknown) => {
          // Don't retry on 404s
          if (error && typeof error === 'object' && 'status' in error && error.status === 404) return false;
          // Retry up to 3 times for other errors
          return failureCount < 3;
        },
      },
      mutations: {
        retry: false,
      },
    },
  });
}
